export function getRequiredCoverageForBusinessType(businessType, employeeCount) {
  const baseCoverage = ['general_liability'];
  if (employeeCount !== 'solo') baseCoverage.push('workers_comp');

  switch (businessType) {
    case 'retail':
    case 'restaurant':
      return [...baseCoverage, 'commercial_property', 'business_interruption'];
    case 'professional_services':
      return [...baseCoverage, 'professional_liability'];
    case 'contractor':
      return [...baseCoverage, 'commercial_auto', 'commercial_property'];
    default:
      return baseCoverage;
  }
}

export function calculateRiskCoverageGaps(riskFactors, coverage) {
  let gaps = 0;
  if (riskFactors.includes('store_customer_data') && !coverage.includes('cyber_liability')) gaps++;
  if (riskFactors.includes('professional_advice') && !coverage.includes('professional_liability')) gaps++;
  if (riskFactors.includes('use_vehicles') && !coverage.includes('commercial_auto')) gaps++;
  if (riskFactors.includes('physical_location') && !coverage.includes('commercial_property')) gaps++;
  if (riskFactors.includes('expensive_equipment') && !coverage.includes('commercial_property')) gaps++;
  return gaps;
}

export function determineResultType(answers) {
  let underinsuredScore = 0;
  let overpayingScore = 0;
  let reviewScore = 0;

  const employeeCount = answers.q2 || 'solo';
  const currentCoverage = answers.q5 || [];
  const lastReview = answers.q4;
  const businessType = answers.q1;
  const mainConcern = answers.q6;
  const riskFactors = answers.q7 || [];
  const businessChanges = answers.q8 || [];

  // CRITICAL CHECK
  if (employeeCount !== 'solo' && !currentCoverage.includes('workers_comp')) {
    underinsuredScore += 50;
  }

  // Q4: Last review
  if (lastReview === 'never' || lastReview === '5_plus_years') {
    underinsuredScore += 15;
    reviewScore += 10;
  } else if (lastReview === 'within_year') {
    overpayingScore += 5;
  }

  // Q5: Coverage gaps
  const requiredCoverage = getRequiredCoverageForBusinessType(businessType, employeeCount);
  const missingCoverage = requiredCoverage.filter(c => !currentCoverage.includes(c));
  
  if (missingCoverage.length >= 3) {
    underinsuredScore += 20;
  } else if (missingCoverage.length === 0 && currentCoverage.length > 3) {
    overpayingScore += 10;
  }

  if (currentCoverage.includes('not_sure')) reviewScore += 15;
  if (currentCoverage.includes('none')) underinsuredScore += 30;

  // Q6: Main concern
  if (mainConcern === 'paying_too_much') overpayingScore += 20;
  else if (mainConcern === 'dont_have_enough') underinsuredScore += 20;
  else if (['dont_understand', 'business_changed'].includes(mainConcern)) reviewScore += 20;

  // Q7: Risk factors
  if (calculateRiskCoverageGaps(riskFactors, currentCoverage) >= 3) {
    underinsuredScore += 15;
  }

  // Q8: Recent changes
  if (businessChanges.length >= 2 && !businessChanges.includes('none')) {
    reviewScore += 15;
    underinsuredScore += 10;
  }

  if (underinsuredScore >= 40) return 'underinsured';
  if (overpayingScore >= 20 && reviewScore < 15) return 'overpaying';
  return 'need_review';
}